import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tress-modal" }
const _hoisted_2 = {
  id: "specialAccessories",
  class: "accessories-popup"
}
const _hoisted_3 = { class: "swal2-actions" }
const _hoisted_4 = ["href"]

import { inject, nextTick, ref, watch } from "vue";
import { Emitter, EventType } from "mitt";
import { ProductApi } from "@/services/Api";
import { ProductTile } from "@/models/ProductList";
import dictionary from "@/i18n/dictionary.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressSpecialAccessoriesModal',
  props: {
  checkOutPageUrl: {
    type: String,
    required: true,
  },
},
  setup(__props) {



const active = ref<boolean>(false);
const specialAccessories = ref<Array<ProductTile>>([]);
const emitter = inject<Emitter<Record<EventType, string>>>("eventbus");

const toggleActive = (ev: MouseEvent | undefined, value: boolean) => {
  if (ev == undefined) {
    active.value = value;
    return;
  }
  const element = ev.target as HTMLElement;
  if (element.classList.contains("tress-modal-container")) {
    active.value = value;
  }
};

if (emitter) {
  emitter.on("special accessories open", (partNo) => {
    ProductApi.getSpecialAccessories(partNo).then((specialAccessoriesResult) => {
      nextTick(() => {
        specialAccessories.value = specialAccessoriesResult ?? [];
        toggleActive(undefined, specialAccessories.value.length > 0);
      });
    });
  });
}

watch(active, () => {
  document.documentElement.style.overflow = active.value ? "hidden" : "unset";
  document.documentElement.style.height = active.value ? "100%" : "unset";
});

return (_ctx: any,_cache: any) => {
  const _component_tress_special_accessories_modal_view = _resolveComponent("tress-special-accessories-modal-view")!

  return (active.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tress-modal-container",
        onClick: _cache[2] || (_cache[2] = (ev) => toggleActive(ev, false))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleActive(undefined, false))),
            type: "button",
            class: "swal2-close"
          }, "×"),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_tress_special_accessories_modal_view, { "special-accessories": specialAccessories.value }, null, 8, ["special-accessories"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (active.value = false)),
                type: "button",
                class: "btn btn-success button button--button-outlined",
                style: {"display":"inline-block"}
              }, _toDisplayString(_ctx.$t(_unref(dictionary).common.continueShopping)), 1),
              _createElementVNode("a", {
                href: __props.checkOutPageUrl,
                class: "btn btn-danger button button--default"
              }, _toDisplayString(_ctx.$t(_unref(dictionary).common.toCheckout)), 9, _hoisted_4)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})